import React, { useMemo, useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import {
  CreateVendorClientTrackingActivity,
  GetContactById,
  UpdateVendorClientTracking,
} from '../../../../../Services';
import {
  getDownloadableLink,
  showError,
  showSuccess,
  sideMenuComponentUpdate,
  sideMenuIsOpenUpdate,
} from '../../../../../Helper';
import useFetchList from '../../../../../Hooks/useFetchData';
import {
  Inputs,
  LoadableImageComponant,
  Spinner,
  PermissionsComponent
} from '../../../../../Components';
import { DefaultImagesEnum } from '../../../../../Enums';
import { CopyToClipboardComponents } from '../../../../../ReusableComponents/UtilityComponents';
import { CallMade, ShowChart } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import CreateLeadDialog from '../../../../../Components/CreateLeadDialog/CreateLeadDialog';
import { LookupSelect } from '../../../ActivitiesTypeView/ActivitiesTypeManagementView/DialogManagementViewComponent/DialogManagementConrtolComponent/LookupSelect';
import ActivitiesTimeline from './ActivitiesTimeline';
import AddActivityDialog from '../Components/AddActivityDialog';
import { useKeyGenerator } from '../../../../../Hooks/keyGenerator';
import { ClientsTrackingPermissions  } from '../../../../../Permissions';

const styles = makeStyles({
  container: {
    '& img': {
      width: '72px',
      height: '72px',
    },
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '18px',
    '& h2': { fontWeight: 600, fontSize: '18px', color: '#3B72D9' },
    '& .copy-container': {
      width: 'fit-content !important',
    },
    '& .contact-name': {
      fontWeight: 600,
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      '& .MuiSvgIcon-fontSizeSmall': {
        fontSize: '16px',
        fill: '#344054',
        alignSelf: 'center',
      },
    },
    '& .btn': {
      borderRadius: '9999px',
      padding: '8px 12px',
      display: 'flex',
      justifyContent: 'space-center',
      alignItems: 'center',
      gap: '4px',
    },
    '& .theme-outline': {
      border: '1px solid #3B72D9 !important',
      color: '#3B72D9 !important',
    },
    '& .card-container': {
      overflow: 'auto',
      maxHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '8px',
      border: '1px solid #EAECF0 !important',
      shadowBox: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      borderRadius: '12px',
      '& .card-title': {
        fontWeight: 600,
        fontSize: '16px',
        color: '#2D3E50',
      },
      '& .card-content': {
        fontWeight: 400,
        fontSize: '14px',
        color: '#475467',
      },
      '& .card-details': {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      },
    },
    '& .divider': {
      margin: '20px 0',
      backgroundColor: '#ccc !important',
      height: '1px !important',
      border: 'none !important',
    },
  },
});
const ClientTrackingSideCard = ({
  contactName,
  contactId,
  vendorOfferName,
  serviceName,
  vendorName,
  invoiceId,
  transactionStatusId,
  psiCommissionStatusId,
  transactionAmount,
  clientFeedback,
  discountPercentage,
  vendorClientTrackingId,
  vendorOfferId,
}) => {

  const classes = styles();
  const { data: contact, loading } = useFetchList(GetContactById, contactId);
  const [key, refresh] = useKeyGenerator();

  const [vendorClientTracking, setVendorClientTracking] = useState({
    vendorOfferId,
    contactId,
    psiCommissionStatusId,
    invoiceId,
    transactionStatusId,
    clientFeedback,
    transactionAmount,
  });
  const [openCreateLeadDialog, setOpenCreateLeadDialog] = useState(false);
  const [openActivitiesDialog, setOpenActivitiesDialog] = useState(false);
  const contactDetails = useMemo(
    () =>
      contact.contactJson ? JSON.parse(contact.contactJson).contact : null,
    [contact]
  );
  const onSaveActivityHandler = async (data) => {
    try {
      data.activityTypeId = data.activityType.activityTypeId;
      await CreateVendorClientTrackingActivity(data);
      showSuccess('create successfully');
      refresh();
    } catch (error) {
      showError('create error');
    } finally {
      setOpenActivitiesDialog(false);
    }
  };

  const updateVendorClientTracking = async () => {
    try {
      await UpdateVendorClientTracking(
        vendorClientTrackingId,
        vendorClientTracking
      );
      showSuccess('update successfully');
    } catch (error) {
      showError('update error');
    }
  };
  const onChangeHandler = (key, value) => {
    setVendorClientTracking({
      ...vendorClientTracking,
      [key]: value,
    });
  };
  if (loading || !contactDetails) {
    return <Spinner isActive isAbsolute />;
  }
  return (
    <div className={classes.container}>
      <h2>Contact Profile</h2>
      <div className="flex gap-1">
        <LoadableImageComponant
          src={
            contactDetails.contact_type_id === 1
              ? getDownloadableLink(
                  contactDetails.contact_image?.["Image Upload"]?.[0].uuid
                ) ?? DefaultImagesEnum.individual.defaultImg
              : getDownloadableLink(
                  contactDetails?.company_logoimage?.["Company Logo"]?.[0]?.uuid
                ) ?? DefaultImagesEnum.corporate.defaultImg
          }
        />
        <div className="d-flex-column gap-6 py-2">
          <span className="contact-name ">
            {contactName}
            <Link
              to={`/home/Contacts-CRM/contact-profile-edit?formType=${contactDetails?.contact_type_id}&id=${contactId}`}
              target="_blank"
              className="flex"
            >
              <CallMade fontSize="small" />
            </Link>
          </span>
          <CopyToClipboardComponents
            data={contactId}
            childrenData={contactId}
          />
          {contactDetails?.landline_number?.phone && (
            <CopyToClipboardComponents
              data={contactDetails?.landline_number.phone}
              childrenData={contactDetails.landline_number.phone}
            />
          )}
          {contactDetails?.mobile?.phone && (
            <CopyToClipboardComponents
              data={contactDetails.mobile.phone}
              childrenData={contactDetails.mobile.phone}
            />
          )}
          {contactDetails?.email_address?.email && (
            <CopyToClipboardComponents
              data={contactDetails.email_address.email}
              childrenData={contactDetails.email_address.email}
            />
          )}
          {contactDetails?.general_email?.email && (
            <CopyToClipboardComponents
              data={contactDetails.general_email.email}
              childrenData={contactDetails.general_email.email}
            />
          )}
        </div>
      </div>
      <div>
        <PermissionsComponent
          permissionsList={Object.values(ClientsTrackingPermissions)}
          permissionsId={
            ClientsTrackingPermissions.CreateLeadForClientTracking.permissionsId
          }
        >
          <Button
            className="btns theme-outline"
            onClick={() => setOpenCreateLeadDialog(true)}
          >
            <span className="mdi mdi-plus" />
            Create Lead
          </Button>
        </PermissionsComponent>
         <PermissionsComponent
          permissionsList={Object.values(ClientsTrackingPermissions)}
          permissionsId={
            ClientsTrackingPermissions.AddActivityForClientTracking.permissionsId
          }
        >
        <Button
          className="btns theme-solid"
          onClick={() => setOpenActivitiesDialog(true)}
        >
          <ShowChart className="mdi " />
          Add Activity
        </Button>
        </PermissionsComponent>
      </div>
      <CreateLeadDialog
        contactId={contactId}
        open={openCreateLeadDialog}
        setOpen={setOpenCreateLeadDialog}
      />
      <AddActivityDialog
        contactId={contactId}
        vendorClientTrackingId={vendorClientTrackingId}
        open={openActivitiesDialog}
        onSave={onSaveActivityHandler}
        onClose={() => setOpenActivitiesDialog(false)}
      />
      <div className="card-container">
        <span className="card-title">Offer Details</span>
        <div className="card-details">
          <span>
            Company Name&nbsp;<strong>{vendorName}</strong>
          </span>
          <span>
            Vendor Name&nbsp;<strong>{vendorName}</strong>
          </span>
          <span>
            Service Category&nbsp;<strong>{serviceName}</strong>
          </span>
          <span>
            Offer Name&nbsp;<strong>{vendorOfferName}</strong>
          </span>
          <span>
            Discount percentage &nbsp;
            <strong>Up to {discountPercentage}%</strong>
          </span>
          <div className="d-flex flex-wrap fj-between fa-center">
            <LookupSelect
              lookupName={"PSICommissionStatus"}
              value={vendorClientTracking.psiCommissionStatusId}
              labelValue={"PSI Commission status"}
              onSelectChanged={(value) =>
                onChangeHandler("psiCommissionStatusId", value)
              }
            />
            <LookupSelect
              lookupName={"TransactionStatusClientTracking"}
              value={vendorClientTracking.transactionStatusId}
              labelValue={"Transaction status"}
              onSelectChanged={(value) =>
                onChangeHandler("transactionStatusId", value)
              }
            />
            <Inputs
              labelValue={"Invoice Number"}
              value={vendorClientTracking.invoiceId ?? ""}
              onInputChanged={(e) =>
                onChangeHandler("invoiceId", e.target.value)
              }
              type={"number"}
            />
            <Inputs
              labelValue={"Transaction Amount"}
              value={vendorClientTracking.transactionAmount ?? ""}
              onInputChanged={(e) =>
                onChangeHandler("transactionAmount", e.target.value)
              }
              type={"number"}
            />
            <Inputs
              labelValue={"Client Feedback"}
              value={vendorClientTracking.clientFeedback ?? ""}
              multiline
              rows={3}
              wrapperClasses={"w-100"}
              onInputChanged={(e) =>
                onChangeHandler("clientFeedback", e.target.value)
              }
            />
          </div>
        </div>
      </div>
      <div className="card-container">
        <span className="card-title">Activity Timeline</span>
        <div className="card-details">
          <ActivitiesTimeline
            vendorClientTrackingId={vendorClientTrackingId}
            key={key}
          />
        </div>
      </div>
      <div className="d-flex-column">
        <hr className={"divider"} />
        <div className="d-flex fj-end">
          <Button
            className="btns theme-outline"
            onClick={() =>
              setVendorClientTracking({
                vendorOfferId,
                contactId,
                psiCommissionStatusId,
                invoiceId,
                transactionStatusId,
                clientFeedback,
                transactionAmount,
              })
            }
          >
            Cancel
          </Button>
          <Button
            className="btns theme-solid"
            onClick={updateVendorClientTracking}
          >
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ClientTrackingSideCard;
